<template>
	<div class="table-edit-container">
		<ModalHeader :title="getString('edit_element')" />
		<AppList :items="settingsItem" />
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import AppList from "@/shared/components/AppList.vue";
import API from "@/shared/helpers/API";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		const userStore = useUserStore();
		return {getString: languageStore.getString, notificationStore, userStore};
	},
	name: "TableEdit",
	components: {AppList, ModalHeader},
	emits: ['deleted'],
	props: {
		roomTableId: {
			type: Number,
			default: null
		}
	},
	computed: {
		settingsItem() {
			return [
				{title: this.getString('delete'), buttonTitle: this.getString('delete'), callbackButton: this.deleteElement},
			];
		},
	},
	methods: {
		deleteElement() {

			API.init().deleteRoomTable(this.userStore.currBusinessId, this.roomTableId, (result) => {
				if(result && result.result === "OK") {
					this.$emit('deleted');
					this.notificationStore.showNotification('generic-success');
				} else {
					this.notificationStore.showNotification('generic-fail');
				}
			});

		}
	}
}
</script>

<style scoped lang="scss">

</style>